<template>
  <section class="section-brief">
    <div class="section-title">
      <span class="dot-left">
        <i></i>
        <i></i>
        <i></i>
      </span>
      {{ $t("content.brief.title") }}
      <span class="dot-right">
        <i></i>
        <i></i>
        <i></i>
      </span>
    </div>
    <!-- 外层统一容器，和嘉宾max-width一致 -->
    <div class="content-wrap">
      <div class="section-content">
        <p>{{ $t("content.brief.desc") }}</p>
      </div>
    </div>
  </section>
</template>

<script>
export default {};
</script>

<style scoped>
.section-brief {
  padding: 50px 40px;
  width: 100%;
}
/* 统一最大宽度 和嘉宾组件1300px完全一致 */
.content-wrap {
  max-width: 1300px;
  margin: 0 auto;
}

.section-title {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 14px;
  font-size: 24px;
  font-weight: 500;
  color: #0f3494;
  margin: 0 0 24px;
}

.dot-left,
.dot-right {
  display: flex;
  align-items: center;
  gap: 2px;
}
.dot-left i,
.dot-right i {
  background-color: #0f3494;
  border-radius: 2px;
}
.dot-left i:nth-child(1) { width: 5px; height: 5px; }
.dot-left i:nth-child(2) { width: 8px; height: 8px; }
.dot-left i:nth-child(3) { width: 12px; height: 12px; }
.dot-right i:nth-child(1) { width: 12px; height: 12px; }
.dot-right i:nth-child(2) { width: 8px; height: 8px; }
.dot-right i:nth-child(3) { width: 5px; height: 5px; }

.section-content {
  padding: 0 10px;
  color: #111;
  line-height: 1.9;
  font-size: 16px;
}
.section-content p {
  margin: 0;
  text-indent: 2em;
  letter-spacing: 0.6px;
}

@media screen and (max-width: 768px) {
  .section-brief {
    padding: 30px 16px 35px;
  }
  .section-title {
    font-size: 20px;
    gap: 10px;
    margin-bottom: 16px;
  }
  .dot-left i:nth-child(3), .dot-right i:nth-child(1) { width: 8px; height: 8px; }
  .dot-left i:nth-child(2), .dot-right i:nth-child(2) { width: 6px; height: 6px; }
  .dot-left i:nth-child(1), .dot-right i:nth-child(3) { width: 4px; height: 4px; }
  .section-content {
    font-size: 14px;
    line-height: 1.8;
  }
  .section-content p {
    letter-spacing: 0.4px;
  }
}
</style>